export const examBoards = ['AQA', 'OCR', 'Edexcel', 'WJEC'];

export const topicCards = [
  {
    id: 1,
    icon: 'ri-code-s-slash-line',
    title: 'Programming',
    description: 'Variables, loops, functions, OOP and more. Master Python and pseudocode.',
    level: 'GCSE',
    color: 'bg-emerald-50',
    iconColor: 'text-emerald-600',
    lessons: 24,
    completed: 14,
  },
  {
    id: 2,
    icon: 'ri-database-2-line',
    title: 'Data Representation',
    description: 'Binary, hex, ASCII, images, sound and data compression techniques.',
    level: 'GCSE',
    color: 'bg-orange-50',
    iconColor: 'text-orange-500',
    lessons: 18,
    completed: 10,
  },
  {
    id: 3,
    icon: 'ri-wifi-line',
    title: 'Networks',
    description: 'LAN, WAN, protocols, TCP/IP, network security and the internet.',
    level: 'GCSE',
    color: 'bg-sky-50',
    iconColor: 'text-sky-600',
    lessons: 20,
    completed: 8,
  },
  {
    id: 4,
    icon: 'ri-flow-chart',
    title: 'Algorithms',
    description: 'Sorting, searching, Big O notation, flowcharts and pseudocode.',
    level: 'A-Level',
    color: 'bg-violet-50',
    iconColor: 'text-violet-600',
    lessons: 22,
    completed: 5,
  },
  {
    id: 5,
    icon: 'ri-shield-keyhole-line',
    title: 'Cyber Security',
    description: 'Threats, encryption, firewalls, social engineering and ethical hacking.',
    level: 'GCSE',
    color: 'bg-rose-50',
    iconColor: 'text-rose-500',
    lessons: 16,
    completed: 12,
  },
  {
    id: 6,
    icon: 'ri-cpu-line',
    title: 'Computer Systems',
    description: 'CPU architecture, memory, storage, operating systems and hardware.',
    level: 'A-Level',
    color: 'bg-amber-50',
    iconColor: 'text-amber-600',
    lessons: 26,
    completed: 9,
  },
];

export const upcomingEvents = [
  {
    id: 1,
    day: '07',
    month: 'Apr',
    title: 'Representation of Images & Sound',
    time: '15:30 – 17:00',
    location: 'Online',
    level: 'GCSE',
  },
  {
    id: 2,
    day: '09',
    month: 'Apr',
    title: 'Cyber Security Booster Session',
    time: '15:30 – 17:00',
    location: 'Online',
    level: 'A-Level',
  },
  {
    id: 3,
    day: '15',
    month: 'Apr',
    title: 'Programming: Inputs & Outputs',
    time: '15:30 – 17:00',
    location: 'Online',
    level: 'GCSE',
  },
  {
    id: 4,
    day: '17',
    month: 'Apr',
    title: 'Representation of Numbers',
    time: '15:30 – 17:00',
    location: 'Online',
    level: 'A-Level',
  },
  {
    id: 5,
    day: '20',
    month: 'Apr',
    title: 'Network Security Deep Dive',
    time: '15:30 – 17:00',
    location: 'Online',
    level: 'GCSE',
  },
];

export const testimonials = [
  {
    id: 1,
    stars: 5,
    headline: 'Achieved Grade 9 in my GCSE!',
    review: 'This platform completely transformed how I revised. The topic breakdowns are crystal clear and the practice questions are spot-on for AQA. I went from a Grade 6 to a Grade 9 in just 3 months.',
    name: 'Emily R.',
    school: 'Year 11 · AQA GCSE',
    avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20smiling%20teenage%20girl%20with%20school%20uniform%2C%20clean%20white%20background%2C%20professional%20headshot%20style%2C%20soft%20natural%20lighting%2C%20realistic%20photo&width=96&height=96&seq=t1&orientation=squarish',
  },
  {
    id: 2,
    stars: 5,
    headline: 'Best CS revision resource out there',
    review: 'The events are incredibly helpful — I attended the algorithms booster and it made everything click. The guides are well-written and the syllabus coverage for OCR A-Level is comprehensive.',
    name: 'James T.',
    school: 'Year 13 · OCR A-Level',
    avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20smiling%20teenage%20boy%20with%20casual%20clothes%2C%20clean%20white%20background%2C%20professional%20headshot%20style%2C%20soft%20natural%20lighting%2C%20realistic%20photo&width=96&height=96&seq=t2&orientation=squarish',
  },
  {
    id: 3,
    stars: 5,
    headline: 'My students love it!',
    review: 'As a CS teacher, I recommend this to all my students. The Edexcel syllabus alignment is perfect and the resources save me hours of prep time. The event sessions are a brilliant addition.',
    name: 'Ms. Sarah K.',
    school: 'CS Teacher · Edexcel',
    avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20smiling%20female%20teacher%20in%20professional%20attire%2C%20clean%20white%20background%2C%20professional%20headshot%20style%2C%20soft%20natural%20lighting%2C%20realistic%20photo&width=96&height=96&seq=t3&orientation=squarish',
  },
];

export const stats = [
  { value: '12,000+', label: 'Active Students' },
  { value: '4', label: 'Exam Boards' },
  { value: '200+', label: 'Revision Topics' },
  { value: '98%', label: 'Pass Rate' },
];

export const examDates = {
  AQA: { paper1: 'Wednesday, 14 May 2025', paper2: 'Wednesday, 4 June 2025' },
  OCR: { paper1: 'Thursday, 15 May 2025', paper2: 'Thursday, 5 June 2025' },
  Edexcel: { paper1: 'Tuesday, 13 May 2025', paper2: 'Tuesday, 3 June 2025' },
  WJEC: { paper1: 'Monday, 12 May 2025', paper2: 'Monday, 2 June 2025' },
};
